//VERIGO OPERATOR

import en_US from '../../en_US';

const extend = {
  tv: 'TV',
  favorites: 'My Favorites'
};

const en_VERIGO = {...en_US, ...extend};

export default en_VERIGO;



// WEBPACK FOOTER //
// ./src/locales/dics/ext/verigo/en_VERIGO.js